import React from "react";
import useToggle from "../../../../Hooks/useToggle";
import MainHeader from "./MainHeader";
import "./index.css";

const HeaderOne = ({ drawerAction }) => {
  const [show, setValue] = useToggle(false);
  return (
    <>
      <MainHeader searchAction={setValue.toggle} drawerAction={drawerAction} />
      <div className="dp-header-spacer"></div>
    </>
  );
};

export default HeaderOne;
